
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.61 11.125c-1.365 0-2.404-.458-3.118-1.375C.784 8.833.43 7.503.43 5.758c0-1.76.393-3.125 1.18-4.094C2.4.695 3.455.211 4.772.211c1.386 0 2.44.458 3.165 1.375.723.911 1.085 2.226 1.085 3.945 0 1.792-.39 3.172-1.171 4.14-.776.97-1.857 1.454-3.243 1.454zM2.007 5.539c0 1.599.234 2.815.703 3.649.474.833 1.164 1.25 2.07 1.25.875 0 1.537-.407 1.985-1.22.453-.817.68-1.937.68-3.359 0-1.609-.238-2.838-.712-3.687C6.266 1.322 5.594.898 4.72.898 2.91.898 2.008 2.445 2.008 5.54zM6.39 4.4V6.82h-.579c-.114-.468-.37-.703-.765-.703h-.64c-.225 0-.389.05-.493.149-.099.093-.187.278-.266.554h-.586V4.398h.586c.105.48.388.72.852.72h.469c.27 0 .463-.053.578-.157.114-.11.203-.297.266-.563h.578z","fill":"currentColor"}})])
          )
        }
      }
    